import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';
import { KeeniconComponent } from '../../../keenicon/keenicon.component';

@Component({
  selector: 'ui-sidebar-footer',
  imports: [KeeniconComponent, TranslocoPipe, RouterLink],
  templateUrl: './sidebar-footer.component.html',
  styleUrl: './sidebar-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarFooterComponent {
  PAGE_ROUTES = input.required<{ [key: string]: string }>();
}
